import React from 'react'


function Brand() {
  return (
	<div className="brand-area">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="brand-item-wrap">
                <ul>
                  <li><a href="/#" target="_blank"><img src="assets/img/images/brand_logo01.png" alt="" /></a></li>
                  <li><a href="/#" target="_blank"><img src="assets/img/images/brand_logo02.png" alt="" /></a></li>
                  <li><a href="/#" target="_blank"><img src="assets/img/images/brand_logo03.png" alt="" /></a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
  )
}

export default Brand